<template>
  <div
    v-if="selectedGlobalDate"
    class="month-picker-wrapper"
    @click="elementClicked"
  >
    <button
      class="is-pulled-left button white-button"
      :disabled="isBefore2019"
      @click="minusOneMonth"
    >
      <i
        class="icon-angle-left"
        aria-hidden="true"
      />
    </button>
    <button
      class="button input-month"
      :class="{open: isOpen}"
      @click="toggleMonthPicker"
    >
      {{ selectedGlobalDate | dateFormat('yyyy MMMM', false) }}
    </button>
    <button
      class="is-pulled-right button white-button"
      :disabled="nextMonthDisabled"
      @click="addOneMonth"
    >
      <i
        class="icon-angle-right"
        aria-hidden="true"
      />
    </button>
    <div
      v-if="isOpen"
      class="month-picker"
    >
      <year-picker
        :currentYearDate="currentYearDate"
        @year-change="setNewYearDate"
      />
      <month-list
        :currentYearDate="currentYearDate"
        :currentMonthDate="currentMonthDate"
        @month-change="setNewMonthDate"
      />
      <button
        class="button latest-month"
        :disabled="latestMonthDisabled"
        @click="setLatestMonthDate"
      >
        Latest Month
      </button>
      <button
        class="button is-primary"
        @click="setSelectedDateToGlobal"
      >
        Apply
      </button>
    </div>
  </div>
</template>

<script>
import {
  setYear,
  subYears,
  addYears,
  getYear,
  isSameYear,
  setMonth,
  getMonth,
  subMonths,
  addMonths,
  isSameMonth } from 'date-fns'
import YearPicker from './YearPicker'
import MonthList from './MonthList'

export default {
  components: {
    YearPicker,
    MonthList
  },
  props: {
    selectedGlobalDate: {
      type: Date,
      required: true
    }
  },
  data () {
    return {
      isOpen: false,
      monthPickerYearDate: null,
      monthPickerMonthdate: null
    }
  },
  computed: {
    currentYearDate () {
      return this.monthPickerYearDate ? this.monthPickerYearDate : this.selectedGlobalDate
    },
    currentMonthDate () {
      return this.monthPickerMonthdate ? this.monthPickerMonthdate : this.selectedGlobalDate
    },
    isThisYear () {
      return isSameYear(this.currentMonthDate, new Date())
    },
    nextMonthDisabled () {
      return isSameMonth(this.selectedGlobalDate, subMonths(new Date(), 1))
    },
    latestMonthDisabled () {
      return this.isThisYear && getMonth(this.currentMonthDate) === getMonth(new Date()) - 1
    },
    isBefore2019 () {
      const lastMonth = new Date(2019, 0)
      return isSameMonth(this.currentMonthDate, lastMonth)
    }
  },
  created () {
    window.addEventListener('click', this.closeMonthPicker, false)
  },
  beforeDestroy () {
    window.removeEventListener('click', this.closeMonthPicker, false)
  },
  methods: {
    elementClicked (e) {
      e.stopPropagation() // stop event bubbling
    },
    toggleMonthPicker () {
      this.isOpen = !this.isOpen
    },
    closeMonthPicker () {
      this.isOpen = false
      this.monthPickerMonthdate = null
      this.monthPickerYearDate = null
    },
    setNewYearDate (change) {
      switch (change) {
        case 'subOne':
          this.monthPickerYearDate = subYears(this.currentYearDate, 1)
          break
        case 'addOne':
          this.monthPickerYearDate = addYears(this.currentYearDate, 1)
          break
        case 'latest':
          if (getMonth(new Date()) === 0) {
            this.monthPickerYearDate = setYear(this.currentYearDate, getYear(new Date()) - 1)
          } else {
            this.monthPickerYearDate = setYear(this.currentYearDate, getYear(new Date()))
          }
          break
        default:
          break
      }
    },
    setNewMonthDate (newMonth) {
      this.monthPickerMonthdate = setYear(
        setMonth(this.currentMonthDate, newMonth),
        getYear(this.currentYearDate)
      )
    },
    setLatestMonthDate () {
      let latestMonth = getMonth(new Date()) - 1
      latestMonth = latestMonth < 0 ? 12 : latestMonth
      this.setNewYearDate('latest')
      this.setNewMonthDate(latestMonth)
    },
    minusOneMonth () {
      const newMonthDate = subMonths(this.selectedGlobalDate, 1)
      this.$emit('new-month-date', newMonthDate)
      this.closeMonthPicker()
    },
    addOneMonth () {
      const newMonthDate = addMonths(this.selectedGlobalDate, 1)
      this.$emit('new-month-date', newMonthDate)
      this.closeMonthPicker()
    },
    setSelectedDateToGlobal () {
      this.$emit('new-month-date', this.currentMonthDate)
      this.closeMonthPicker()
    }
  }
}
</script>

<style scoped lang="scss">
.month-picker-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.month-picker {
  position: absolute;
  top: 50px;
  right: 0;
  z-index: 9;
  display: block;
  width: 430px;
  height: 310px;
  border: $border-superlight;
  border-radius: $border-radius;
  background: $white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.button {
  border-radius: $border-radius;
}

.input-month {
  min-width: 164px;
  height: 30px;
  padding: 0;
  border: $border-base;
  border-radius: 0;
}

.open {
  border: 1px solid #c8c8c8 !important;
  background: #ececec;
}

.year-picker {
  margin: 40px auto 0;
}

.months {
  padding: 20px 40px;
}

.latest-month {
  display: block;
  margin: auto;
  padding: 5px 50px;
  font-size: 10px;
  line-height: 1;
}

.is-primary {
  float: right;
  margin: 20px 40px 40px 0;
  padding: 5px 30px;
}

.active {
  border: 1px solid rgba(0, 0, 0, 0.2);
  color: $white;
  background: #16c6b9;

  &:hover,
  &:focus,
  &:focus:not(:active) {
    border: 1px solid rgba(0, 0, 0, 0.2);
    color: $white;
  }
}
</style>
